//
import 'utils/serialize_object';

(function ($) {
  'use strict';

  class AjaxForm {
    constructor($form, options) {
      this.$form = $form;
      this.successMessage = $form.data().successMessage;
      this.errorMessage = $form.data().errorMessage;
      this.options = options;

      this.$form.on('ajax:success', this.onSuccess.bind(this));
      this.$form.on('ajax:error', this.onError.bind(this));
    }

    onSuccess() {
      if (this.successMessage) toastr.success(this.successMessage);

      if (this.options.clearOnSuccess)
        this.$form.clearForm(this.options.clearHidden);
    }

    onError() {
      if (this.errorMessage) toastr.error(this.errorMessage);
    }
  }

  // jQuery Plugin
  if (!$.fn.ajaxForm) {
    $.fn.ajaxForm = function (clearOnSuccess = true, clearHidden = false) {
      const $form = $(this);

      if (!$form.is('form') || $form.get(0).ajaxForm) return $form;

      $form.get(0).ajaxForm = new AjaxForm($form, {
        clearOnSuccess: clearOnSuccess,
        clearHidden: clearHidden
      });

      return $form;
    };
  }
})(jQuery);
